import script from "./HeaderSection.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderSection.vue?vue&type=script&setup=true&lang=js"

import "./HeaderSection.vue?vue&type=style&index=0&id=3f1944e4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f1944e4"]])

export default __exports__